import { render, staticRenderFns } from "./case-file.vue?vue&type=template&id=78524044&"
import script from "./case-file.vue?vue&type=script&lang=js&"
export * from "./case-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports